import { render, staticRenderFns } from "./ScreenLaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=template&id=1f7226c2&lang=true&"
import script from "./ScreenLaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports